import type { ReactNode, FC } from "react";
import { cx } from "../../../utils";

interface CheckboxCardProps {
  className?: string;
  label: ReactNode;
  wrapperClassName?: string;

  id: string;
  name: string;
  checked?: boolean;
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;

  disabled?: boolean;

  error?: string;
}

export const CheckboxCard: FC<CheckboxCardProps> = ({
  label,
  className,
  wrapperClassName,
  onChange,
  disabled,
  error,
  ...props
}) => {
  const isActive = Boolean(props.checked);

  return (
    <div className={cx("relative", wrapperClassName)}>
      <label
        className={cx(
          "bg-content-1000-inverted block rounded-lg p-4 transition-all duration-200 ease-in-out",
          disabled
            ? "cursor-not-allowed opacity-50"
            : "cursor-pointer hover:shadow-md",
          // eslint-disable-next-line no-nested-ternary -- that's fine
          error
            ? "border-danger-500 border"
            : isActive
              ? "border-primary-500 border-2 shadow-sm"
              : "border-alpha-100 shadow-xs border",
          className
        )}
        htmlFor={!disabled ? props.id : undefined}
      >
        {typeof label === "string" ? (
          <span className="text-alpha-900 block text-center text-base font-bold">
            {label}
          </span>
        ) : (
          label
        )}
      </label>

      <input
        className="absolute opacity-0"
        onChange={(e) => {
          if (!disabled) {
            onChange(e);
          }
        }}
        type="checkbox"
        disabled={disabled}
        {...props}
      />
    </div>
  );
};
